/**
 * Coquette stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const coquetteStickersPack: ToilePack = {
    slug: 'coquette-stickers',
    category: 'sticker',
    name: 'Coquette stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'bow', label: 'Satin bow', subject: 'a pink satin ribbon bow'},
        {key: 'cake', label: 'Strawberry cake', subject: 'a slice of strawberry cream cake'},
        {key: 'pearl', label: 'Pearl heart', subject: 'a heart made of a string of pearls'},
    ],
    styles: [
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'doodle', label: 'Hand-drawn', style: 'hand-drawn marker doodle sticker, loose line, flat wash fills', palette: 'Two or three muted colours with a black line', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['a lace ribbon instead', 'a whole sticker sheet', 'in red colors'],
    directionHint: 'try: a lace ribbon instead',
    seo: {
        title: 'Coquette Stickers: Bow, Cake, Pearl Heart',
        metaDescription: 'Nine coquette aesthetic stickers — a satin bow, strawberry cake, a pearl heart — in kawaii, bold cartoon, and hand-drawn styles.',
        h1: 'Coquette stickers: satin bow, strawberry cake, pearl heart',
        tagline: 'Nine stickers, three coquette icons, three styles each.',
        intro: 'A pink satin ribbon bow, a slice of strawberry cream cake, and a heart made of a string of pearls — three coquette aesthetic stickers, die-cut and ready to print. Each rendered kawaii, bold cartoon, and loose hand-drawn. Ask for a different colour bow, a vanity-table scene, or a lace composition, and the same three styles carry it.',
        useCases: [
            'a laptop or water bottle',
            'a planner or journal page',
            'a phone case sticker sheet',
            'a vanity mirror or makeup bag',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine coquette aesthetic stickers — a satin bow, strawberry cake, and a pearl heart — in kawaii, bold cartoon, and hand-drawn finishes.'},
            {q: 'Can I get a different colour bow or scene?', a: 'Yes — the direction field takes any variation, including a different colour bow, a vanity-table scene, or a lace composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Is this a photo of a real cake or bow?', a: 'No — every sticker is an original illustration, not a photograph.'},
        ],
    },
}
